import './styles.scss';
import Banner from 'components/Banner';
import image from 'images/404-banner.jpg';

const Page404 = () => (
    <section className="container page-404">
        <Banner image={image} buttonText="Go to Homepage" buttonType="banner" withCrumbs={false}>
            <h2>Page not found</h2>
            <p className="body1 opacity-80">
                It is possible that an incorrect address was entered or the page was deleted
            </p>
        </Banner>
    </section>
);

export default Page404;
